<template>
  <div id="step3" :class="{ 'big-screen': !$vuetify.breakpoint.xsOnly }">
    <v-btn v-if="$vuetify.breakpoint.xsOnly && !menu" @click="openMenu()" color="primary" class="box-shadow" icon>
      <v-icon>search</v-icon>
    </v-btn>

    <v-menu v-model="menu" v-if="!$vuetify.breakpoint.xsOnly || menu" offset-y>
      <template v-slot:activator="{ on }">
        <v-text-field ref="search" :loading="isSearching" @input="menu = true" v-on="on" class="mt-2" v-model="search" append-icon="search" label="Jump to Station" clearable color="white" solo :items="filteredItems" item-text="primaryName" item-value="id" return-object />
      </template>
      <v-card>
        <v-layout>
          <v-flex xs12 flexbox>
            <v-subheader>{{ title }}</v-subheader>
            <v-list two-line>
              <v-list-tile v-for="(item, index) in shownLocations" :to="{name: 'monitoringfeature', params: { monitoringFeatureId: item.id }}" @click="clearSearch()" :key="`item-${index}`" active-class="activeStation">
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.primaryName }}<span class="stationHere caption float_right">You are here</span>
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    <span v-if="item.allNames.length">Data types: </span>
                    <v-chip small v-for="(dataType, subIindex) in item.dataTypes" :key="subIindex">
                      {{ dataType.type }}
                    </v-chip>
                    <!-- From Analyte_Refactor App.vue -->
                    <!-- <v-list-tile-sub-title v-if="search">
                           <v-tooltip bottom>
                             <template v-slot:activator="{ on }">
                               <div v-on="on" class="text_hidden">
                                 <span v-if="s.Alias.length">Alias: </span>
                                 <v-chip small v-for="(i, index) in s.Alias" :key="index">{{ i }}</v-chip>
                               </div>
                             </template>
                             <span>
                               <span v-for="(i, index) in s.Alias" :key="index">
                                 {{ i }}<span v-if="index != s.Alias.length-1">,&nbsp;</span>
                               </span>
                             </span>
                           </v-tooltip>
                         </v-list-tile-sub-title> -->
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <!-- From Analyte_Refactor App.vue -->
              <!-- <v-list-tile v-if="$vuetify.breakpoint.xsOnly" @click="
                        showSearching = false;
                        searchOpen = false;
                      " style="background-color: gainsboro; border-style: solid; border-width: 1px; border-color: lightgray">
                       <v-list-tile-title style="font-weight: bold">
                         <v-icon style="padding-bottom: 4px">close</v-icon>{{ $t("Button.Close") }}
                       </v-list-tile-title>
                     </v-list-tile> -->
            </v-list>
          </v-flex>
        </v-layout>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const navigation = createNamespacedHelpers('navigation')

  import {
    debounce,
    defaultDebounceDelay,
  } from '@/helpers/performance'

  import {
    getObjectValues,
    customSearcher,
  } from '@/helpers/search'

  export default {
    data: () => ({
      filteredStationsList: [],
      maxItemsShown: 10,
      menu: false,
      search: '',
      filteredItems: [],
      isSearching: false,
    }),
    computed: {
      ...navigation.mapGetters(['recentLocationIds', 'searchableLocationItems']),
      searchItemsIndex() {
        let index = {}
        this.searchableLocationItems.forEach(item => index[item.id] = item)
        return index
      },
      searchItemValues() {
        let index = {}
        this.searchableLocationItems.forEach(item => {
          let result = getObjectValues(item, 'primaryName', 'allNames')
          index[item.id] = result
        })
        return index
      },
      customSearch() {
        return customSearcher(this.searchItemValues, 'id')
      },
      onSearch() {
        return debounce(function executable(value) {
          let items = this.customSearch(this.searchableLocationItems, value)
          this.filteredItems = items
          this.isSearching = false
        }, defaultDebounceDelay)
      },
      recentLocations() {
        let locations = []
        this.recentLocationIds.forEach(mfId => {
          let mf = this.searchItemsIndex[mfId]
          if (!mf) return
          locations.push(mf)
        })
        return locations
      },
      shownLocations() {
        let result = this.search ? this.filteredItems : this.recentLocations
        if (!result) return []

        result = result.slice(0, this.maxItemsShown)
        return result
      },
      title() {
        return this.search ? `Found ${this.filteredItems.length} matching locations` : 'Most recent locations'
      },
    },
    watch: {
      search(value) {
        this.isSearching = true
        this.onSearch(value)
      },
      menu(val) {
        this.$emit('showSearching', val)
      },
    },
    methods: {
      async openMenu() {
        this.menu = true
        await this.$nextTick()
        this.$refs.search.focus()
      },
      clearSearch() {
        this.search = ''
      },
    },
  }
</script>

<style scoped>
  .big-screen {
    width: 33%;
  }
</style>